// _getGlobalLocale :: Effect String
exports._getGlobalLocale = function() {
  return I18n.locale;
};
